import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-051b58f5"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "an-modal-bg" }
const _hoisted_2 = { class: "an-modal-header has-text-weight-medium" }
const _hoisted_3 = { class: "an-modal-content" }
const _hoisted_4 = { class: "an-modal-footer" }

import { useI18n } from 'vue-i18n';

export default /*#__PURE__*/_defineComponent({
  __name: 'CustomModal',
  props: {
    width: {},
    minWidth: {}
  },
  emits: ['close'],
  setup(__props: any) {

const { t } = useI18n();



return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "an-modal",
      style: _normalizeStyle({ ...(_ctx.width ? { maxWidth: _ctx.width } : {}), ...(_ctx.minWidth ? { minWidth: _ctx.minWidth } : {}) })
    }, [
      _createElementVNode("div", _hoisted_2, [
        _renderSlot(_ctx.$slots, "modal-header")
      ]),
      _createElementVNode("div", _hoisted_3, [
        _renderSlot(_ctx.$slots, "default")
      ]),
      _createElementVNode("div", _hoisted_4, [
        _renderSlot(_ctx.$slots, "modal-footer", {}, () => [
          _createVNode(_component_el_button, {
            size: "small",
            class: "button is-radius-small has-text-weight-semibold",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('common.close')), 1)
            ]),
            _: 1
          })
        ])
      ])
    ], 4)
  ]))
}
}

})